<template>
  <div class="video-dialogue">
    <div class="left-column">
      <div class="controls">
        <div class="title">
          <router-link :to="{ name: 'kyrgyz_language_dialogues'}" class="back-button">&#8249;</router-link>

      <b>{{dialogue.index}}. {{dialogue.title}}</b></div>
      <!-- Rounded switch -->
      <div class="switches">
      <div class="control-switch">
  
        <div class="switch-title">
          Translation
        </div>
      <label class="switch">
        <input type="checkbox" v-model="showTranslation">
        <span class="slider round"></span>
      </label>
    </div>
      <div class="control-switch">
        <div class="switch-title">
            Latin
        </div>
      <label class="switch">
        <input type="checkbox" v-model="showLatin">
        <span class="slider round"></span>
      </label>
      </div>
    </div>
      </div>

    <div class="text">
      <div v-for="(line, index) in dialogue.lines" :key="index">
        <div class="sentence" :class="current(index)">
          <span v-tooltip="{
          content: getParsedText(word),
          classes: ['info']}" class="word" v-for="(word, index) in line.words" :key="index">{{ showLatin ? word.latin : word.word }}</span>
</div>

        <div v-show="showTranslation" class="translation">{{line.translation}}</div>
    </div>
    </div>
  </div>

    <div class="right-column">
    <div class="video">
    <video-player 
      :options="videoOptions"
      @statechanged="playerStateChanged($event)"></video-player>
    </div>
    <div class="credits">
    Project Director: Gulmira Dyusheva Music: Nurak Abdyrakhmanov Photos: Sultan Dosaliev Zarnigar Abdullaeva, Kelgembaytegin Elnur. Editor: Zholdosh Turdubaev.
    Implemented with the support of the Soros Foundation - Kyrgyzstan. 
    This video is licensed under the <a href="https://creativecommons.org/licenses/by-sa/3.0/us/">CC-BY-SA (Creative Commons Attribution-ShareAlike)</a> license, which allows you to copy and distribute material on any medium and in any format
    </div>
    </div>

  </div>
</template>

<script>
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";

export default {
  name: "InteractiveDialogue",
  props: {
    dialogue: Object,
    videoOptions: Object
  },
  computed: {
    times() {
      return this.dialogue.lines.map(line =>
        Math.floor(Number(line.start_time))
      );
    }
  },
  data() {
    return {
      activeLine: -1,
      activeTooltip: null,
      showTranslation: false,
      showLatin: false
    };
  },
  components: {
    videoPlayer
  },
  methods: {
    current(index) {
      if (index === this.activeLine) {
        return "current";
      }
    },
    getParsedText(word) {
      return word.definition;
      // const parsed = word.parsed;

      // if (word.parsed.length == 0) {
      //   return word.definition;
      // }

      // const simpleParsed = Object.keys(parsed).reduce(function(ac, key) {
      //   return ac + "-" + key;
      // });

      // const bottomLine = Object.values(parsed).reduce(function(ac, value) {
      //   if (ac === "") {
      //     return value.definition;
      //   }
      //   return ac + "-" + value.definition;
      // }, "");

      // return simpleParsed + "\n" + bottomLine;

      // const parsedString = Object.entries(parsed).reduce(function (ac, pair) {
      //   const [key, value] = pair;
      //   const str = key + '(' + value.definition + ')'
      //   if (ac === '') {
      //     return str;
      //   } else {
      //     return ac + '-' + str;
      //   }
      // }, '');

      // return parsedString;
    },
    playerStateChanged(playerCurrentState) {
      if (playerCurrentState.timeupdate) {
        const currentTime = Math.floor(playerCurrentState.timeupdate);
        const index = this.times.findIndex(k => k === currentTime);
        if (index > 0) {
          this.activeLine = index;
        }
      }
      if (playerCurrentState.ended === true) {
        this.activeLine = -1;
      }
    },
    toggleLineTooltip(index) {
      if (index === this.activeTooltip) {
        this.activeTooltip = null;
      } else {
        this.activeTooltip = index;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Spectral:500,500i");

$secondary_color: #084696;

@mixin for-phone-only {
  @media (max-width: 599px) {
    @content;
  }
}
@mixin for-tablet-portrait-up {
  @media (min-width: 600px) {
    @content;
  }
}
@mixin for-tablet-landscape-up {
  @media (min-width: 900px) {
    @content;
  }
}
@mixin for-desktop-up {
  @media (min-width: 1200px) {
    @content;
  }
}
@mixin for-big-desktop-up {
  @media (min-width: 1800px) {
    @content;
  }
}

.tooltip {
  display: block !important;
  z-index: 10000;
  .tooltip-inner {
    // height: 100px;
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }
  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
  }
  &[x-placement^="top"] {
    margin-bottom: 5px;
    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }
  &[x-placement^="bottom"] {
    margin-top: 5px;
    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }
  &[x-placement^="right"] {
    margin-left: 5px;
    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }
  &[x-placement^="left"] {
    margin-right: 5px;
    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }
  &[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }
  &[aria-hidden="false"] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
  &.info {
    $color: rgba($secondary_color, 0.9);

    .tooltip-inner {
      background: $color;
      color: white;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, 0.1);
      max-width: 250px;
    }

    .tooltip-arrow {
      border-color: $color;
    }
  }
}

.video-dialogue {
  top: 0px;
  bottom: 0;
  left: 0;
  position: absolute;
  @include for-phone-only() {
    overflow: scroll;
  }

  overflow: hidden;
  display: flex;
  flex-flow: row wrap;
  // Columns
  > * {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .left-column {
    padding-right: 10px;
    @include for-phone-only() {
      padding-right: 0px;
      padding-top: 10px;
    }

    /* The switch - the box around the slider */
    .controls {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      padding-bottom: 10px;
      justify-content: space-between;

      .back-button {
        flex: 0;
        text-decoration: none;
        display: inline-block;
        background-color: #ddd;
        color: black;
        border-radius: 50%;
        // margin: auto;
        margin-right: 10px;
        max-height: 34px;
        font-size: 24px;
        padding: 0px 12px;

        &:hover {
          background-color: $secondary_color;
          color: white;
        }
      }
      .title {
        font-family: "Spectral", serif;
        font-size: 20px;
        padding-right: 10px;
        // width:100%;
      }

      .switches {
        display: flex;
        .control-switch {
          display: flex;
          flex-direction: row;

          .switch-title {
            padding: 6px;
            font-size: 14px;
            text-align: center;
          }

          .switch {
            flex: none;
            flex-flow: row-wrap;
            position: relative;
            display: inline-block;
            width: 60px;
            height: 34px;
          }
        }
      }
    }

    .text {
      flex: 1;
      font-family: "Spectral", serif;
      overflow-y: auto; /*adds scroll to this container*/
      font-size: 18px;

      .translation {
        font-style: italic;
        color: $secondary_color;
      }

      .current {
        text-decoration: underline;
      }

      .sentence {
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        .word {
          &::after {
            white-space: pre;
            content: "\A0";
          }
        }
      }
    }
  }

  .right-column {
    @include for-phone-only() {
      order: -1;
      padding: 0px;
    }
    flex: 1;
    min-width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .video {
      flex: 1;
      width: 100%;
      height: 100%;
    }

    .credits {
      font-size: 10px;
      color: grey;

      @include for-phone-only() {
        display: none;
      }
    }
  }
}

/* Hide default HTML checkbox */
.switch input {
  display: none;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: $secondary_color;
}

input:focus + .slider {
  box-shadow: 0 0 1px $secondary_color;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
